export enum PodcastTypes {
    AgilePodcast="Agile Podcast",
    Agile="Agile",
    AutomationExplanation="Automation Explanation",
    AIPodcast="AI Podcast",
    Default="Default"
}